module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-head"
  }, [_c('a', {
    staticClass: "head-logo",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo-100",
    attrs: {
      "src": require("../assets/logo-s.png"),
      "alt": ""
    },
    on: {
      "click": _vm.gohome
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "head-btn-a",
    on: {
      "click": _vm.goOther
    }
  }, [_vm._v(_vm._s(_vm.path.indexOf('adjust_home') ? '配单' : '流程'))])])]), _vm._v(" "), _c('div', {
    staticClass: "head-user"
  }, [_c('div', {
    staticClass: "user-info qh-btn"
  }, [_c('span', {
    staticClass: "head-btn-a"
  }, [_vm._v(_vm._s(_vm.getLabel(_vm.oilArea)))]), _vm._v(" "), _c('div', {
    staticClass: "choose-ps"
  }, _vm._l((_vm.pszxDatas), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.oilArea = item.key
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))])]), _vm._v(" "), _c('user-info'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.path) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01d142e7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeadAdjust.vue
// module id = 944
// module chunks = 1